import React from "react";
import TodaysTaskTile from "../../components/ServiceRequests/Handholder/TodaysTaskTile";
import ServiceRequestList from "../../components/ServiceRequests/Handholder/ServiceRequestList";
import ServiceRequestDetailsModal from "../../components/ServiceRequests/Handholder/ServiceRequestDetailsModal";
import { useEffect } from "react";
import groupBy from "lodash/groupBy";
import api from "../../utils/api";
import { useState } from "react";
import { toast } from "react-toastify";
import UserProfileModal from "../../components/ServiceRequests/Handholder/UserProfileModal";
import Spinner from "../../common/Spinner/Spinner";
import CancellationReasonModal from "../../components/ServiceRequests/Handholder/CancellationReasonModal";
import SendNeftDetails from "../../components/ServiceRequests/Handholder/SendNeftDetails";
import ConfirmUnsavedDataModal from "../../components/ServiceRequests/Handholder/ConfirmUnsavedDataModal";
import MultiSelectAll from "../../common/Multiselect/MultiSelectAll";
import SelectFollowupDateDropdown from "../../components/ServiceRequests/Handholder/SelectFollowupDateDropdown";
import SelectServiceRequestStatusDropdown from "../../components/ServiceRequests/Handholder/SelectServiceRequestStatusDropdown";
import Select from "react-select";
import { Button } from "../../common/Button/Button";

export default function ServiceRequestsContainer(props) {
	/**CancellationReason */

	const [
		showCancellationReasonModal,
		setShowCancellationReasonModal,
	] = useState(false);
	const toggleCancellationReasonModal = () => {
		setShowCancellationReasonModal(!showCancellationReasonModal);
	};

	const [showUnsavedDataModal,setshowUnsavedDataModalModal,] = useState(false);
	const toggleUnsavedDataModal = () => {setshowUnsavedDataModalModal(!showUnsavedDataModal);};

	const [showConfirmationModal,setShowConfirmationModal,] = useState(false);
	const toggleConfirmationModal = () => {setShowConfirmationModal(!showConfirmationModal);};

	const [
		cancellationReasonDropdownOptions,
		setCancellationReasonDropdownOptions,
	] = useState();
	const [
		selectedCancellationReason,
		setSelectedCancellationReason,
	] = useState();

	const [
		enableOtherDescriptionTextbox,
		setEnableOtherDescriptionTextbox,
	] = useState(false);

	const [
		cancellationReasonOtherDescription,
		setCancellationReasonOtherDescription,
	] = useState();

	const [enableCancelButtonFlag, setEnableCancelButtonFlag] = useState(
		"disable"
	);
	useEffect(() => {
		enableCancelButton();
	}, [selectedCancellationReason, cancellationReasonOtherDescription]);

	const enableCancelButton = () => {
		if (selectedCancellationReason) {
			if (selectedCancellationReason.value === "Other") {
				if (
					cancellationReasonOtherDescription &&
					cancellationReasonOtherDescription.length > 0
				) {
					setEnableCancelButtonFlag("");
				} else setEnableCancelButtonFlag("disable");
			} else setEnableCancelButtonFlag("");
		} else setEnableCancelButtonFlag("disable");
	};

	const [isLoading, setIsLoading] = useState(false);
	const [serviceRequestList, setServiceRequestList] = useState([]);
	const [serviceRequestCount, setServiceRequestCount] = useState(0);
	const [
		serviceRequestHandledTodayCount,
		setServiceRequestHandledTodayCount,
	] = useState(0);

	const [selectedServiceRequest, setSelectedServiceRequest] = useState({});
	const [
		showServiceRequestModal,
		setServiceRequestModalVisibility,
	] = useState(false);

	const [
		isCurrentTabVisible,
		setisCurrentTabVisible,
	] = useState(true);

	const [
		masterServiceRequestStates,
		setMasterServiceRequestStates,
	] = useState([]);
	/**
	 * service request modal data
	 */
	const [
		serviceRequestEditableData,
		setServiceRequestEditableData,
	] = useState({});
	const [catalogueByServiceRequest, setCatalogueByServiceRequest] = useState(
		[]
	);
	const [isLoadingInModal, setLoadingInModal] = useState(false);

	const [isUnsavedData, setisUnsavedData] = useState(false);
	const [isAllFieldsArevallid, setisAllFieldsArevallid] = useState(false);

	/**
	 * catalogue modal data
	 */
	const [showCatalogueModal, setCatalogueModalVisibility] = useState(false);
	const [selectedCatalogue, setSelectedCatalogue] = useState(null);
	const [catalogueMode, setCatalogueMode] = useState("");

	/**
	 * NEFT modal data
	 */
	const [showNeftModal, setNeftModalVisibility] = useState(false);
	const [neftDetails, setNeftDetails] = useState({});

	/**
	 * User profile modal data
	 */
	const [showUserProfileModal, setUserProfileModalVisibility] = useState(
		false
	);
	const [userProfileInitData, setUserProfileInitData] = useState({});
	const [userProfileEditableData, setUserProfileEditableData] = useState({});
	const [callButtonColor, setCallButtonColor] = useState("red");
	const [nUserId, setUserId] = useState(false);

	const [showSendNeftDetailsModal, onSetShowSendNeftDetailsModal] = useState(
		false
	);
	const [neftPaymentDetails, onSetNeftPaymentDetails] = useState({});

	const [nResourceInstanceId, setnResourceInstanceId] = useState();

	/*Service Filter logic change states*/
	const [serviceNameListForFilter, setServiceNameListForFilter] = useState([]);
	const [selectedServiceNameListForFilter, setSelectedServiceNameListForFilter] = useState([]);
	const [serviceRequestStatusList, setServiceRequestStatusList] = useState([]);
	const [followUpDateTo, setFollowUpDateTo] = useState("");
	const [followUpDateFrom, setFollowUpDateFrom] = useState("");
	const [selectedServiceRequestStatusList,setSelectedServiceRequestStatusList,] = useState([]);

	const [nResourceInstanceIdForUserProfileLPM, setnResourceInstanceIdForUserProfileLPM] = useState();

	const [ServiceHandeledStatusOptions,setServiceHandeledStatusOptions,] = useState([
	{
		value: "all",
		label: "All",
	},
	{
		value: "yes",
		label: "Yes",
	},
	{
		value: "no",
		label: "No",
	},
	]);
	const [
		selectedServiceHandeledStatus,
		setselectedServiceHandeledStatus,
	] = useState({
		value: "all",
		label: "All",
	});
	/*Service Filter logic change states end*/

	/*Need to talk to SP*/
	const [needToTalkToSPOptions,setneedToTalkToSPOptions] = useState([
		{
			value: true,
			label: "Yes",
		},
		{
			value: false,
			label: "No",
		},
		]);
		const [
			selectedNeedToTalkToSPOption,
			setSelectedNeedToTalkToSPOption,
		] = useState({
			value: false,
			label: "No",
		});

	useEffect(() => {
		/**
		 * fetch master list of all handholders in the system
		 */
		api.getDisableFalseServiceRequestsNames({
			bDisableService:false
		}).then(({ data }) => {
			const serviceReqNamesForFilter = Object.keys(data).map((idx) => {
				return {
					label: data[idx].sServiceName,
					id: data[idx].id,
					value: data[idx].sServiceCode,
				};
			});
			setServiceNameListForFilter(serviceReqNamesForFilter);
		});

		api.getAllServiceRequestsStatus().then(({ data }) => {
			const serviceReqStatus = Object.keys(data).map((idx) => {
				return {
					checked: selectedServiceRequestStatusList.includes(
						data[idx].id
					),
					label: data[idx].sSRState,
					id: data[idx].sSRState,
					code: data[idx].sSRState,
				};
			});
			setServiceRequestStatusList(serviceReqStatus);
		});
	}, []);

	const setShowSendNeftDetailsModal = (data, nResourceInstanceId) => {
		onSetShowSendNeftDetailsModal(data);
		setnResourceInstanceId(nResourceInstanceId);
		if (data) {
			api.getNeftAccountDetails().then(({ data }) => {
				onSetNeftPaymentDetails(data);
			});
		}
	};

	const onClickSendNeftAccountDetails = () => {
		
		api.sendNeftAccountDetails({
			sEmailAddress: selectedServiceRequest["sEmailAddress"],
			nResourceInstanceId: nResourceInstanceId,
		})
			.then(({ data }) => {
				onSetShowSendNeftDetailsModal(false);
				toast(data["details"], {
					autoClose: 3000,
					type: toast.TYPE.SUCCESS,
				});
			})
			.catch((e) => {
				onSetShowSendNeftDetailsModal(true);
				toast("Something went wrong. Contact webadmin support.", {
					autoClose: 3000,
					type: toast.TYPE.ERROR,
				});
			});
	};

	// User has switched back to the tab
const onFocus = () => {
	setisCurrentTabVisible(true);
  };
  
  // User has switched away from the tab (AKA tab is hidden)
  const onBlur = () => {
	setisCurrentTabVisible(false);
  };
  
	useEffect(() => {
		window.addEventListener('focus', onFocus);
		window.addEventListener('blur', onBlur);
		// Specify how to clean up after this effect:
		return () => {
			window.removeEventListener('focus', onFocus);
			window.removeEventListener('blur', onBlur);
		};
	});

	useEffect(() => {
		const interval = setInterval(() => 
		{
			getMyServiceRequestsForInterval();

		}, 10000);
		return () => clearInterval(interval);
	  }, [isCurrentTabVisible,selectedServiceNameListForFilter,
		selectedServiceRequestStatusList,followUpDateFrom,followUpDateTo,selectedServiceHandeledStatus]);

	useEffect(() => {
		getMyServiceRequests();
		setIsLoading(true);
		api.getMasterServiceRequestStates().then(({ data }) => {
			const cancelledRemoved = data.filter((state) => {
				if (state.sSRState === "Cancelled") return false;
				return true;
			});
			// const i = findIndex(data,{sSRState:"Prepared"});
			// insert(data,i,{id:"SEND_PAYMENT_CTA",sSRSState:"Send Payment Link"})
			// data.filter((state) => {
			//   if(state)
			// })
			setMasterServiceRequestStates(cancelledRemoved);
		});
		const { temp } = api.getCancellationReasons().then(({ data }) => {
			console.log("cancellationRason", data);
			let temp1 = data.map((e) => {
				return { value: e.sReason, label: e.sReason };
			});
			setCancellationReasonDropdownOptions(temp1);
		});

		setIsLoading(false);
	}, []);
	const [customerProfileData, setCustomerProfileData] = useState();
	const [DNDDate, setDNDDate] = useState();

	const calculateEnableOtherDescriptionTextbox = () => {
		if (
			selectedCancellationReason &&
			selectedCancellationReason.value === "Other"
		)
			setEnableOtherDescriptionTextbox(true);
		else setEnableOtherDescriptionTextbox(false);
	};
	useEffect(() => {
		calculateEnableOtherDescriptionTextbox();
	}, [selectedCancellationReason]);
	useEffect(() => {
		setSelectedCancellationReason();
		setCancellationReasonOtherDescription();
		if (selectedServiceRequest && cancellationReasonDropdownOptions) {
			let temp = cancellationReasonDropdownOptions.map((e) => {
				if (e.value === selectedServiceRequest.sCancellationReason) {
					setSelectedCancellationReason(e);
					if (e.value === "Other") {
						setCancellationReasonOtherDescription(
							selectedServiceRequest.sCancellationReasonOtherDescription
						);
					}
				}
			});
		}

		// setSelectedCancellationReason();
	}, [selectedServiceRequest]);
	useEffect(() => {
		const {
			sServiceCode,
			sCatalogueId,
			sNEFTDetails,
			sNEFTTxnId_1,
			fAmountReceived_1,
			bNEFTPayment,
			nUserId,
		} = selectedServiceRequest;
		setUserId(nUserId);
		if (sServiceCode) getCatalogue(sServiceCode);
		if (sCatalogueId && sCatalogueId.length > 0) {
			setSelectedCatalogue(sCatalogueId);
		}
		if (bNEFTPayment) {
			setNeftDetails({
				sNEFTDetails,
				bNEFTPayment,
				sNEFTTxnId_1,
				fAmountReceived_1,
			});
		} else {
			setNeftDetails({});
		}

		if (
			selectedServiceRequest.nUserId ||
			selectedServiceRequest.sEmailAddress
		) {
			api.getUserProfileData({
				nUserId: selectedServiceRequest.nUserId,
				sEmailAddress: selectedServiceRequest.sEmailAddress,
			}).then(({ data }) => {
				const { customer_profile_data } = data;
				setCustomerProfileData(customer_profile_data);
			});
		}
		if (
			selectedServiceRequest.sEmailAddress
		) {
			api.getDNDDate({
				sEmailAddress: selectedServiceRequest.sEmailAddress,
			}).then(({ data }) => {
				const { dnd_date } = data;
				setDNDDate(dnd_date);
			});
		}

		if(selectedServiceRequest.bNeedToTalkToSP)
		{
			setSelectedNeedToTalkToSPOption({
				value: true,
				label: "Yes",
			})
		}
		else
		{
			setSelectedNeedToTalkToSPOption({
				value: false,
				label: "No",
			})
		}

	}, [selectedServiceRequest]);

	const getMyServiceRequests = (updateSelectedServiceRequestFlag = false) => {
		setIsLoading(true);
		let serviceRequestListtemp2 = [];
			selectedServiceNameListForFilter.map((e) => {
				serviceRequestListtemp2.push(e.value);
			});
			const serviceRequestList=serviceRequestListtemp2
			const statusList = selectedServiceRequestStatusList;
			const fromDate = followUpDateFrom;
			const toDate = adjustedToDate(followUpDateTo);
			const ServiceHandeledStatus = selectedServiceHandeledStatus;
		api.getMyServiceRequests(
			ServiceHandeledStatus,serviceRequestList,statusList,fromDate,toDate
		).then(({ data }) => {
			const results = data.map((x)=>{
				x.sEmailAddress=x.sEmailAddress.toLowerCase();
				return x;
			});
			const groupedByCustomerEmail = groupBy(results, "sEmailAddress");
			setServiceRequestList(groupedByCustomerEmail);
			if (updateSelectedServiceRequestFlag) {
				const { sEmailAddress } = selectedServiceRequest;
				let temp = groupedByCustomerEmail[sEmailAddress].filter(
					(e) =>
						e.nResourceInstanceId ===
						selectedServiceRequest.nResourceInstanceId
				)[0];
				console.log("&&&&", temp);
				setSelectedServiceRequest(temp);
			}
			setServiceRequestCount(results.length);
			let today = new Date();
			let temp = results.filter(
				(e) =>
					new Date(e.dtLastHandled).getDate() === today.getDate() &&
					new Date(e.dtLastHandled).getMonth() === today.getMonth() &&
					new Date(e.dtLastHandled).getFullYear() ===
						today.getFullYear()
			);
			setServiceRequestHandledTodayCount(temp.length);
		});
		setIsLoading(false);
	};

	const getMyServiceRequestsForInterval = () => {
		if(isCurrentTabVisible)
		{
			let serviceRequestListtemp2 = [];
			selectedServiceNameListForFilter.map((e) => {
				serviceRequestListtemp2.push(e.value);
			});
			const serviceRequestList=serviceRequestListtemp2
			const statusList = selectedServiceRequestStatusList;
			const fromDate = followUpDateFrom;
			const toDate = adjustedToDate(followUpDateTo);
			const ServiceHandeledStatus = selectedServiceHandeledStatus;
			//document.title= 'Call Made With Server';
			api.getMyServiceRequests
			(
				ServiceHandeledStatus,serviceRequestList,statusList,fromDate,toDate
			).then(({ data }) => {
				const results = data.map((x)=>{
					x.sEmailAddress=x.sEmailAddress.toLowerCase();
					return x;
				});
				const groupedByCustomerEmail = groupBy(results, "sEmailAddress");
				setServiceRequestList(groupedByCustomerEmail);
				setServiceRequestCount(results.length);
				let today = new Date();
				let temp = results.filter(
					(e) =>
						new Date(e.dtLastHandled).getDate() === today.getDate() &&
						new Date(e.dtLastHandled).getMonth() === today.getMonth() &&
						new Date(e.dtLastHandled).getFullYear() ===today.getFullYear()
				);
				setServiceRequestHandledTodayCount(temp.length);
			});
		}
		else{
			//document.title= 'Call Failed';
		}
	};

	const handleServiceRequestClick = (serviceRequest) => {
		if (serviceRequest["dtLastHandled"]) {
			setCallButtonColor("green");
		} else {
			setCallButtonColor("red");
		}
		setServiceRequestModalVisibility(true);
		serviceRequest.sEmailAddress=serviceRequest.sEmailAddress.toLowerCase();
		setSelectedServiceRequest(serviceRequest);
	};

	/**
	 * 'ALL DONE' (handle) service request callbacks.
	 */
	const toggleModal = () => {
		setServiceRequestEditableData({});
		setisUnsavedData(false);
		setisAllFieldsArevallid(false);
		setServiceRequestModalVisibility(!showServiceRequestModal);
	};
	const handleUpdateServiceRequest = async () => {
		const {
			sFollowupNotes,
			sNotes,
			dtFollowupOn: followUpDate,
		} = serviceRequestEditableData;
		if (!sFollowupNotes || !sNotes || !followUpDate) {
			toast("Please enter required fields.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		setLoadingInModal(true);
		const { nResourceInstanceId } = selectedServiceRequest;
		const dtFollowupOn = followUpDate.toISOString();
		var payload = {
			sFollowupNotes,
			sNotes,
			dtFollowupOn,
			nResourceInstanceId,
		};

		if(selectedNeedToTalkToSPOption)
		{
			payload = { ...payload, bNeedToTalkToSP:selectedNeedToTalkToSPOption.value };
		}
		var str=payload;
		try {
			// eslint-disable-next-line
			const data = await api
				.updateServiceRequest(payload)
				.then(() => {
					getMyServiceRequests(true);
					//toggleModal();
					setServiceRequestEditableData({sFollowupNotes:'',sNotes:''});
					setisUnsavedData(false);
					setisAllFieldsArevallid(false);
					if(showUnsavedDataModal)
					{
						toggleUnsavedDataModal();
					}					
					toast("Service Request handled successfully.", {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
				})
				.catch((error) => {
					toast(String(error.response.data.Error), {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch (error) {
			// toast("Something went wrong. Contact webadmin support.", {
			//   autoClose: 5000,
			//   type: toast.TYPE.ERROR,
			// });
		} finally {
			setLoadingInModal(false);
		}
	};
	const handleServiceRequestModalDataChange = (name, value) => {
		const updated = { ...serviceRequestEditableData, [name]: value };
		setServiceRequestEditableData(updated);

		const {
			sFollowupNotes,
			sNotes,
			dtFollowupOn: followUpDate,
		} = updated;
		if (sFollowupNotes || sNotes || followUpDate)
		{
			setisUnsavedData(true);
			if(sFollowupNotes && sNotes && followUpDate)
			{
				setisAllFieldsArevallid(true);
			}
			else
			{
				setisAllFieldsArevallid(false);
			}
		}
		else
		{
			setisUnsavedData(false);
			setisAllFieldsArevallid(false);
		}
	};

	/**
	 * Service request STATE UPDATE callbacks
	 */
	const handleSendPaymentLink = async () => {
		try {
			setIsLoading(true);
			const { nResourceInstanceId } = selectedServiceRequest;

			const {
				data: { message },
			} = await api.sendPaymentLink({ nResourceInstanceId });

			const { status, message: serverMessage } = message;
			if (status === "success") {
				const payload = {
					nResourceInstanceId,
					sSRState: "Partial Payment Pending",
				};
				// eslint-disable-next-line no-unused-vars
				const { data: _ignore_ } = await api.changeServiceRequestState(
					payload
				);
				const { data } = await api.getServiceRequestById(
					nResourceInstanceId
				);
				data.sEmailAddress=data.sEmailAddress.toLowerCase();
				setSelectedServiceRequest(data);
				toast(`Payment link sent successfully.`, {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});
			} else {
				toast(`${serverMessage}`, {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				//show error and message
			}
		} catch (error) {
			toast(`Something went wrong.Contact webadmin support.`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		} finally {
			setLoadingInModal(false);
			getMyServiceRequests();
		}
		setIsLoading(false);
		setShowConfirmationModal(false);
	};
	const handleChangeState = async (state) => {
		try {
			setIsLoading(true);
			const {
				nResourceInstanceId,
				sEmailAddress,
			} = selectedServiceRequest;
			let cancellation_Reason, OtherDescription;
			if (selectedCancellationReason) {
				cancellation_Reason = selectedCancellationReason.value;
				if (cancellation_Reason !== "Other") OtherDescription = null;
				else OtherDescription = cancellationReasonOtherDescription;
			}
			const payload = {
				nResourceInstanceId,
				sSRState: state,
				cancellationReason: cancellation_Reason,
				cancellationReasonOtherDescription: OtherDescription,
			};
			// eslint-disable-next-line no-unused-vars
			const { data: _ignore_ } = await api
				.changeServiceRequestState(payload)
				.then((d) => {
					if (d.data) {
						// if (d.data["SR"]["bMovedToSPM"] === true) {
						if (
							d?.data?.SR?.bMovedToSPM === true ||
							d?.data?.message === "Service Moved To SPM"
						) {
							toast(`Moved to SPM`, {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
						} else if (d.data["SR"]["refSRState"] === "Cancelled") {
							toggleCancellationReasonModal();
							toast(`Service request cancelled successfully.`, {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
						} else {
							toast(`Service Request updated successfully.`, {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
						}
						getMyServiceRequests(true);
					}
				})
				.catch((error) => {
					toast(String(error.response.data.message), {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
			const data = await api
				.getServiceRequestById(nResourceInstanceId)
				.then((d) => {
					return d.data;
				})
				.catch((error) => {
					toast(String(error.response.data.Error), {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
			data.sEmailAddress=data.sEmailAddress.toLowerCase();
			setSelectedServiceRequest(data);
			toast(`Service request updated successfully.`, {
				autoClose: 5000,
				type: toast.TYPE.SUCCESS,
			});
		} catch (error) {
		} finally {
			setLoadingInModal(false);
			getMyServiceRequests();
		}
		setIsLoading(false);
	};

	/**
	 * Catalogue callbacks
	 */
	const togglCatalogueModal = () => {
		setCatalogueModalVisibility(!showCatalogueModal);
	};
	const getCatalogue = async (sServiceCode) => {
		try {
			const { data } = await api.getCatalogueForServiceRequest(
				sServiceCode
			);
			setCatalogueByServiceRequest(data);
			setCatalogueMode(data[0]["sMode"].split("_")[0]);
		} catch (error) {
			console.log(error);
		}
	};
	const saveCatalogue = async () => {
		try {
			setIsLoading(true);
			const { nResourceInstanceId } = selectedServiceRequest;
			const payload = {
				nResourceInstanceId,
				sCatalogueId: selectedCatalogue,
			};
			// eslint-disable-next-line no-unused-vars
			const { data: _ignore_ } = await api.saveCatalogueForServiceRequest(
				payload
			);
			const { data } = await api.getServiceRequestById(
				nResourceInstanceId
			);
			setSelectedServiceRequest(data);
			toast(`Service request updated successfully.`, {
				autoClose: 5000,
				type: toast.TYPE.SUCCESS,
			});
			togglCatalogueModal();
		} catch (error) {
			console.log(error);
		}
		setIsLoading(false);
	};

	/**
	 * NEFT callbacks
	 */
	const toggleNeftModal = () => {
		setNeftModalVisibility(!showNeftModal);
	};
	const handleNeftDetailsChanged = (name, value) => {
		if (name === "sNEFTTxnId") {
			if (/^[a-z0-9]*$/i.test(value) === false) return;
			name = name.concat("_1");
		}
		if (name === "fAmountReceived") {
			if (/^[0-9]*$/i.test(value) === false) return;
			if (value === undefined || value === "") value = 0;
			name = name.concat("_1");
		}
		const updated = { ...neftDetails, [name]: value };
		setNeftDetails(updated);
	};
	const handleSaveNeftDetails = async () => {
		//make api call to save details.

		const {
			sNEFTDetails,
			bNEFTPayment,
			sNEFTTxnId_1,
			fAmountReceived_1 = 0,
		} = neftDetails;

		if (
			fAmountReceived_1 === 0 &&
			sNEFTTxnId_1 &&
			sNEFTTxnId_1.length > 0
		) {
			toast(`Amount is required.`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		if (
			(sNEFTTxnId_1 === undefined || sNEFTTxnId_1 === "") &&
			fAmountReceived_1 &&
			fAmountReceived_1.length > 0
		) {
			toast(`Transaction id is required.`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		setIsLoading(true);
		// let fAmountReceived = 0;
		// if (fAmountReceived_1 !== undefined || fAmountReceived_1 !== "")
		// 	fAmountReceived = 0;
		if ((sNEFTDetails && sNEFTDetails.length > 0) || bNEFTPayment) {
			try {
				const { nResourceInstanceId } = selectedServiceRequest;
				// eslint-disable-next-line no-unused-vars
				const { data: _ignore_ } = await api.saveNeftDetails({
					sNEFTDetails,
					bNEFTPayment: true,
					sNEFTTxnId_1,
					fAmountReceived_1,
					nResourceInstanceId,
				});
				toast(`NEFT details updated successfully.`, {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});
				getMyServiceRequests(true);
			} catch (error) {
				toast(`Something went wrong. Contact webadmin support.`, {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			} finally {
				toggleNeftModal();
			}
		} else {
			toggleNeftModal();
		}
		setIsLoading(false);
	};

	/**
	 * User Profile callbacks
	 */
	const toggleUserProfileModal = () => {
		setUserProfileModalVisibility(!showUserProfileModal);
	};
	const handleUserProfileDataChanged = (name, value) => {
		const updated = { ...userProfileEditableData, [name]: value };
		setUserProfileEditableData(updated);
	};
	// eslint-disable-next-line no-unused-vars
	const handleSaveUserProfileData = async () => {
		//make api call to save details.
		const { sNEFTDetails } = neftDetails;
		if (sNEFTDetails && sNEFTDetails.length > 0) {
			try {
				const { nResourceInstanceId } = selectedServiceRequest;
				// eslint-disable-next-line no-unused-vars
				const { data: _ignore_ } = await api.saveNeftDetails({
					sNEFTDetails,
					bNEFTPayment: true,
					nResourceInstanceId,
				});
				toast(`NEFT details updated successfully.`, {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});
			} catch (error) {
				toast(`Something went wrong.Contact webadmin support.`, {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			} finally {
				toggleNeftModal();
			}
		} else {
			toggleNeftModal();
		}
	};
	const createUserProfile = async () => {
		try {
		} catch (error) {}
	};

	const updateSelectedServiceRequest = (data) => {
		data.sEmailAddress=data.sEmailAddress.toLowerCase();
		setSelectedServiceRequest(data);
	};
	const [
		currentServiceRequestIndex,
		setCurrentServiceRequestIndex,
	] = useState(0);
	const changeSelectedServiceRequest = (direction) => {
		let currentServiceRequestIndex;
		let currentServiceRequest = serviceRequestList[
			selectedServiceRequest["sEmailAddress"]
		].map((e, index) => {
			if (
				e.nResourceInstanceId ===
				selectedServiceRequest["nResourceInstanceId"]
			) {
				currentServiceRequestIndex = index;
			}
			return e;
		});

		if (direction == "previous" && currentServiceRequestIndex > 0) {
			currentServiceRequestIndex -= 1;
		}

		if (
			direction == "next" &&
			currentServiceRequestIndex <
				serviceRequestList[selectedServiceRequest["sEmailAddress"]]
					.length -
					1
		) {
			currentServiceRequestIndex += 1;
		}
		let newSelectedServiceRequest =
			serviceRequestList[selectedServiceRequest["sEmailAddress"]][
				currentServiceRequestIndex
			];

		if (newSelectedServiceRequest["dtLastHandled"]) {
			setCallButtonColor("green");
		} else {
			setCallButtonColor("red");
		}
		setCurrentServiceRequestIndex(currentServiceRequestIndex);
		newSelectedServiceRequest.sEmailAddress=newSelectedServiceRequest.sEmailAddress.toLowerCase();
		setSelectedServiceRequest(newSelectedServiceRequest);
	};


	/* Search Filters callbacks */
	const adjustedToDate = (date) => {
		let toDateAdjusted;
		if (date) {
			toDateAdjusted = new Date(date);

			toDateAdjusted = new Date(
				toDateAdjusted.setTime(
					toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
				)
			);
		}
		return toDateAdjusted;
	};

	const toggleStatusSelection = (e) => {
		let temp = selectedServiceRequestStatusList;
		if (!temp.includes(e)) {
			temp = temp.concat(e);
			let tempSrStatus = serviceRequestStatusList.map((x) => {
				if (x.id == e) {
					x.checked = true;
				}
				return x;
			});
			setServiceRequestStatusList(tempSrStatus);
			setSelectedServiceRequestStatusList(temp);
			// getAllServiceRequests(tableInstance)
		} else {
			let idx = temp.indexOf(e);
			temp.splice(idx, 1);
			let tempSrStatus = serviceRequestStatusList.map((x) => {
				if (x.id == e) {
					x.checked = false;
				}
				return x;
			});
			setServiceRequestStatusList(tempSrStatus);
			setSelectedServiceRequestStatusList(temp);
			// getAllServiceRequests(tableInstance);
		}
	};
	const toggleAllForFilter = () => 
	{
		let temp =[];
		
		if (selectedServiceNameListForFilter.length != serviceNameListForFilter.length && selectedServiceNameListForFilter.length!=(serviceNameListForFilter.length+1)) 
		{
			if(selectedServiceNameListForFilter.includes({label: "All", value: "*"}))
			{
				temp = selectedServiceNameListForFilter;
			}
			else
			{
				temp =[{label: "All", value: "*"}];
			}

			let tempSR = serviceNameListForFilter.map((e) => 
			{
				if (!temp.includes(e)) 
				{
					temp = temp.concat(e);
				}
				return e;
			});
			setSelectedServiceNameListForFilter(temp);
			setServiceNameListForFilter(tempSR);
		} 
		else
		{
			setSelectedServiceNameListForFilter([]);
		}
	};

	const toggleSelectionForFilter = (e) => {
		setSelectedServiceNameListForFilter(e);
	};

	const handleSearchClick = async () => 
	{
		getMyServiceRequests();
	};
	const handleClearFilterSearch = () => 
	{
		setSelectedServiceNameListForFilter([]);
		setselectedServiceHandeledStatus({
			value: "all",
			label: "All",
		});
		let tempSrStatus = serviceRequestStatusList.map((x) => {
			x.checked = false;
			return x;
		});
		setServiceRequestStatusList(tempSrStatus);
		setSelectedServiceRequestStatusList([])
		setFollowUpDateFrom();
		setFollowUpDateTo();
		getMyServiceRequests();
	};

	/*Search Filters callbacks end */
	return (
		<div className={`mt-4 ${isLoading && "set-opacity"}`}>
			{isLoading && <Spinner className="center-screen" />}
			<TodaysTaskTile count={serviceRequestCount} />
			<TodaysTaskTile
				text="Tasks handled today"
				count={serviceRequestHandledTodayCount}
			/>
			<TodaysTaskTile
				text="Remaining Tasks"
				count={serviceRequestCount-serviceRequestHandledTodayCount}
			/>
			<a
				style={{ marginLeft: "15px" }}
				target="_blank"
				href="/home/three-sixty-degree-view"
			>
				{" "}
				To 360 degree view
			</a>

			<div className="row" style={{marginTop:"5px"}}>
				<div className="col-md-12 inline-margin-adminview" style={{marginLeft:"15px",marginRight:"15px"}}>
					<label>
						<b>Filter and search</b>
					</label>
					<div className="multi-select"> 
					<MultiSelectAll
							toggleAll={toggleAllForFilter}
							toggleSelection={toggleSelectionForFilter}
							checkboxItemsList={serviceNameListForFilter}
							selectedOptions={selectedServiceNameListForFilter}
							placeholderButtonLabel={"Select Services"}
					/>
					</div>

					<SelectServiceRequestStatusDropdown
						toggleStatusSelection={toggleStatusSelection}
						checkboxItemsList={serviceRequestStatusList
						}
					/>

					<SelectFollowupDateDropdown
						followUpDateTo={followUpDateTo}
						followUpDateFrom={followUpDateFrom}
						setFollowUpDateTo={setFollowUpDateTo}
						setFollowUpDateFrom={setFollowUpDateFrom}
					/>
					<div className="small-dropdown">
						<label style={{marginTop:"5px"}}><b>Services Handeled:</b></label>
						<Select
							placeholder="Select Moved to SPM status"
							options={ServiceHandeledStatusOptions}
							onChange={setselectedServiceHandeledStatus}
							value={selectedServiceHandeledStatus}
						></Select>
					</div>
					<Button className="inline-button" onClick={handleSearchClick}>Search</Button>
					<Button className="inline-button" onClick={handleClearFilterSearch}>
						Clear
					</Button>
				</div>
					</div>

			<ServiceRequestList
				serviceRequestList={serviceRequestList}
				onServiceRequestClick={handleServiceRequestClick}
				onUserProfileClick={(e) => {
					const { nUserId, sEmailAddress, nResourceInstanceId} = selectedServiceRequest;
					e.sEmailAddress=e.sEmailAddress.toLowerCase();
					setSelectedServiceRequest(e);
					setUserProfileInitData(selectedServiceRequest);
					// toggleModal();
					toggleUserProfileModal();
					setnResourceInstanceIdForUserProfileLPM(nResourceInstanceId);
				}}
			/>

			<ServiceRequestDetailsModal
				toggleUnsavedDataModal={toggleUnsavedDataModal}
				toggleCancellationReasonModal={toggleCancellationReasonModal}
				customerProfileData={customerProfileData}
				DNDDate={DNDDate}
				isLoading={isLoading}
				currentServiceRequestIndex={currentServiceRequestIndex}
				serviceRequestList={serviceRequestList}
				//service request details modal data
				onNavigationButtonClick={changeSelectedServiceRequest}
				callButtonColor={callButtonColor}
				isOpen={showServiceRequestModal}
				isLoadingInModal={isLoadingInModal}
				isUnsavedData={isUnsavedData}
				isAllFieldsArevallid={isAllFieldsArevallid}
				serviceRequestReadOnlyData={selectedServiceRequest}
				serviceRequestEditableData={serviceRequestEditableData}
				masterServiceRequestStates={masterServiceRequestStates}
				toggleModal={toggleModal}
				onUpdateServiceRequest={handleUpdateServiceRequest}
				onInputChange={handleServiceRequestModalDataChange}
				onSendPaymentLink={handleSendPaymentLink}
				onChangeState={handleChangeState}
				onUserProfileClick={() => {
					const { nUserId, sEmailAddress, nResourceInstanceId } = selectedServiceRequest;
					setUserProfileInitData(selectedServiceRequest);
					// toggleModal();
					toggleUserProfileModal();
					setnResourceInstanceIdForUserProfileLPM(nResourceInstanceId);
				}}
				//catalogue selection modal data
				isCatalogueModalOpen={showCatalogueModal}
				togglCatalogueModal={togglCatalogueModal}
				selectedCatalogue={selectedCatalogue}
				catalogueByServiceRequest={catalogueByServiceRequest}
				onCatalogueSelected={setSelectedCatalogue}
				catalogueMode={catalogueMode}
				onSaveCatalogue={saveCatalogue}
				//neft modal data
				isNeftModalOpen={showNeftModal}
				toggleNeftModal={toggleNeftModal}
				neftDetails={neftDetails}
				onNeftDetailsChanged={handleNeftDetailsChanged}
				onSaveNeftDetails={handleSaveNeftDetails}
				showSendNeftDetailsModal={showSendNeftDetailsModal}
				setShowSendNeftDetailsModal={setShowSendNeftDetailsModal}
				needToTalkToSPOptions={needToTalkToSPOptions}
				selectedNeedToTalkToSPOption={selectedNeedToTalkToSPOption}
				setSelectedNeedToTalkToSPOption={setSelectedNeedToTalkToSPOption}
				toggleConfirmationModal={toggleConfirmationModal}
				showConfirmationModal={showConfirmationModal}

			/>

			<UserProfileModal
				isOpen={showUserProfileModal}
				toggleModal={toggleUserProfileModal}
				userProfileInitData={userProfileInitData}
				userProfileEditableData={userProfileEditableData}
				onInputChange={handleUserProfileDataChanged}
				createUserProfile={createUserProfile}
				updateSelectedServiceRequest={updateSelectedServiceRequest}
				nUserId={nUserId}
				nResourceInstanceIdForUserProfileLPM={nResourceInstanceIdForUserProfileLPM}
			/>
			<CancellationReasonModal
				isDisabled={enableCancelButtonFlag}
				isOpen={showCancellationReasonModal}
				toggleModal={toggleCancellationReasonModal}
				cancellationReasonDropdownOptions={
					cancellationReasonDropdownOptions
				}
				onSelectCancellationReason={setSelectedCancellationReason}
				selectedCancellationReason={selectedCancellationReason}
				enableOtherDescriptionTextbox={enableOtherDescriptionTextbox}
				cancellationReasonOtherDescription={
					cancellationReasonOtherDescription
				}
				onChangeCancellationReasonOtherDescription={(value) => {
					setCancellationReasonOtherDescription(value);
				}}
				onChangeState={handleChangeState}
			></CancellationReasonModal>
			{showSendNeftDetailsModal && (
				<SendNeftDetails
					isOpen={showSendNeftDetailsModal}
					toggleModal={onSetShowSendNeftDetailsModal}
					neftPaymentDetails={neftPaymentDetails}
					// getNeftPaymentDetails={getNeftPaymentDetails}
					onClickSendNeftAccountDetails={
						onClickSendNeftAccountDetails
					}
				/>
			)}

			<ConfirmUnsavedDataModal
				isOpen={showUnsavedDataModal}
				toggleModal={toggleUnsavedDataModal}
				onUpdateServiceRequest={handleUpdateServiceRequest}
			></ConfirmUnsavedDataModal>
		</div>
	);
}
